import { ColdHoursConfigType } from './types';

export interface ValidationErrors {
  [key: string]: string;
}

const getDaysInMonth = (month: number): number => {
  const daysInMonth: { [key: number]: number } = {
    1: 31,
    2: 29,
    3: 31,
    4: 30,
    5: 31,
    6: 30,
    7: 31,
    8: 31,
    9: 30,
    10: 31,
    11: 30,
    12: 31,
  };
  return daysInMonth[month] || 31;
};

const validateMonthDay = (
  month: number,
  day: number,
  monthField: string,
  dayField: string,
  errors: ValidationErrors,
) => {
  if (!month || month < 1 || month > 12) {
    errors[monthField] = 'El mes debe estar entre 1 y 12';
  }
  if (!day || day < 1 || day > 31) {
    errors[dayField] = 'El día debe estar entre 1 y 31';
  }
  if (month && day) {
    const maxDays = getDaysInMonth(month);
    if (day > maxDays) {
      errors[dayField] = `El día no puede ser mayor a ${maxDays} para el mes seleccionado`;
    }
  }
};

const validateTemperature = (temp: number, field: string, errors: ValidationErrors) => {
  if (temp === undefined || temp === null) {
    errors[field] = 'La temperatura es requerida';
  } else if (temp < -50 || temp > 50) {
    errors[field] = 'La temperatura debe estar entre -50°C y 50°C';
  }
};

export const validateConfig = (config: ColdHoursConfigType): ValidationErrors => {
  const errors: ValidationErrors = {};

  validateMonthDay(
    config.coldHoursStartMonth,
    config.coldHoursStartDay,
    'coldHoursStartMonth',
    'coldHoursStartDay',
    errors,
  );

  validateMonthDay(
    config.coldHoursEndMonth,
    config.coldHoursEndDay,
    'coldHoursEndMonth',
    'coldHoursEndDay',
    errors,
  );

  validateTemperature(config.coldHoursBaseTemp, 'coldHoursBaseTemp', errors);

  validateMonthDay(
    config.accumulatedDegreesStartMonth,
    config.accumulatedDegreesStartDay,
    'accumulatedDegreesStartMonth',
    'accumulatedDegreesStartDay',
    errors,
  );

  validateMonthDay(
    config.accumulatedDegreesEndMonth,
    config.accumulatedDegreesEndDay,
    'accumulatedDegreesEndMonth',
    'accumulatedDegreesEndDay',
    errors,
  );

  validateTemperature(config.accumulatedDegreesBaseTemp, 'accumulatedDegreesBaseTemp', errors);

  return errors;
};
